<template>
    <div>
      <TopAside/>
      <Content/>
      <FootAside/>
    </div>
</template>
<script>
import TopAside from './component/top-aside.vue'
import Content from './component/content.vue'
import FootAside from './component/foot-aside.vue'
export default {
  name: 'Layout',
  components: {
      TopAside,
      Content,
      FootAside
  },
  created() {
    //滚动触发
    window.addEventListener('scroll', () => {
        const headerEl = document.querySelector('header')
        document.querySelector('header')
        const scrollToTop = document.querySelector('.scrollToTop')
        let height = headerEl.style.height
        if(this.$route.path=='/index' || this.$route.path=='/'){
          if (window.pageYOffset - height > 800) {
              if (!headerEl.classList.contains('sticky')) {
                  headerEl.classList.add('sticky')
              }
          } else {
              headerEl.classList.remove('sticky')
          }
        }
        if (window.pageYOffset > 2000) {
            scrollToTop.style.display = 'block'
        } else {
            scrollToTop.style.display = 'none'
        }
    })
  },
  mounted: function () {//页面加载完执行判断，如何不是主页，则把菜单的样式永远用sticky
    if(this.$route.path!='/index' && this.$route.path!='/'){
      console.log('不是主页')
      const headerEl = document.querySelector('header')
      headerEl.classList.add('sticky')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/layout/index.vue